import { Values } from './context';
import { SEARCH_TYPE_NAMES } from './constants';
import { SearchType } from './types';

type Errors = Record<keyof Values, string>;

export const validate = (
  { destination, datepicker, departure }: Values,
  searchType: SearchType
) => {
  const errors = {} as Errors;

  if (!destination) {
    errors.destination = 'Required';
  }
  if (!datepicker && destination) {
    errors.datepicker = 'Required';
  }
  if (!departure && destination && datepicker && searchType === SEARCH_TYPE_NAMES.PACKAGE) {
    errors.departure = 'Required';
  }
  return errors;
};
